// import "./SingleProduct.scss";
// import RelatedProducts from "./RelatedProducts/RelatedProducts";
import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaPinterest,
    FaCartPlus,
} from "react-icons/fa";
// import prod from "../../assets/products/earbuds-prod-3.webp";
import { useState, useContext } from "react";
// import useFetch from "../../hooks/useFetch";
import { useParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { Context } from "../../../utils/context";
// import { Context } from "../../utils/context";
import whatsappLogo from "../../../assets/whatsapp.jpg"
import { Link } from "react-router-dom";

const CategorySingleProduct = () => {
    const [quantity, setQuantities] = useState(1);
    const {id} = useParams();
    const {data} = useFetch(`/api/sale-products?populate=*&[filters][id]=${id}`);

    const {handleAddToCart} = useContext(Context);

    const increment = () => {
        setQuantities((prevState) => prevState + 1)
    }

    const decrement = () => {
        setQuantities((prevState) =>  {
            if(prevState === 1) return 1
            return prevState -1
        })
    }

    if(!data) return;
    const saleProduct = data.data[0].attributes

    return (
        <div className="single-product-main-content">
            <div className="layout">
                <div className="single-product-page">
                    <div className="left">
                        <img src={process.env.REACT_APP_DEV_URL + saleProduct.img.data[0].attributes.url} alt="" />
                    </div>
                    <div className="right">
                        <span className="name">{saleProduct.title}</span>
                        <span className="price">&#8377;{saleProduct.price}</span>
                        <span className="desc">{saleProduct.desc}</span>
                        <div className="cart-button">
                            <div className="quantity-buttons">
                            <span onClick={decrement}>-</span>
                            <span>{quantity}</span>
                            <span  onClick={increment}>+</span>
                        </div>
                        
                        {/* <select >
                            <option value="">{product.size}XS</option>
                            <option value="">{product.size}S</option>
                            <option value="">{product.size}L</option>
                            <option value="">{product.size}XL</option>
                            <option value="">{product.size}XXL</option>
                            
                        </select> */}
                        
                        <button className="add-to-cart-button"
                         onClick={() => {
                            handleAddToCart(data.data[0], quantity)
                            setQuantities(1);
                        }}><FaCartPlus size={20}/>  ADD TO CART</button>

                        </div>
                        <span className="divider" />

                    <div className="info-item">
                        <span className="text-bold">Category:{" "}
                        <span>{saleProduct.saleCategories?.data[0]?.attributes?.title}</span>
                        {/* <span>{product.saleCategories.data[0].attributes.title}</span> */}
                        </span>

                        <span className="text-bold">Share:
                        <span className="social-icons">
                            <FaFacebookF size={16} />
                            <FaInstagram size={16} />
                            <FaLinkedinIn size={16} />
                            <FaTwitter size={16} />
                            <FaPinterest size={16} />
                        </span>
                        </span>
                        
                    </div>
                        
                    </div>
                    

                    
                </div>
                {/* <RelatedProducts productId={id} categoryId={product.categories.data[0].id} /> */}
                <div style={{width:"40px",height:"40px",position:"fixed",right:"10px",bottom:"10px",float:"right"}}>
                    <Link to="https://wa.me/919653217981">
        <img src={whatsappLogo}  style={{width:"60px", border:"1px solid white", borderRadius:"50%",cursor:"pointer" }} alt="" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CategorySingleProduct;
